const DEFAULT_PERSONALIZED_RECOMMENDATIONS_EXPERIMENT_KEY =
  'personalized-product-recommendations-v1';

// Keep production on the canonical key while allowing branch-scoped staging
// builds to use an isolated Sanity experiment. This prevents staging QA
// assignments and exposure events from entering the production experiment's
// cohort or PostHog readout.
export const PERSONALIZED_RECOMMENDATIONS_EXPERIMENT_KEY =
  import.meta.env.VITE_PERSONALIZED_RECOMMENDATIONS_EXPERIMENT_KEY?.trim() ||
  DEFAULT_PERSONALIZED_RECOMMENDATIONS_EXPERIMENT_KEY;

export const PERSONALIZED_RECOMMENDATIONS_VARIANT = 'variant-a';
